import { type BaseSyntheticEvent } from "react";

interface ILabelledInput {
  label?: string;
  placeholder?: string;
  valueUpdater?: (value: string) => void;
  reference?: any;
  isPassword?: boolean;
  focus?: boolean;
  width?: string;
  height?: string;
  marginTop?: string;
  align?: string;
  disable?: boolean;
}
export const LabelledInput = ({
  label,
  placeholder,
  valueUpdater,
  reference,
  isPassword,
  focus,
  width,
  height,
  marginTop,
  align,
  disable
}: ILabelledInput) => {
  const onChange = (event: BaseSyntheticEvent) => {
    if (valueUpdater) valueUpdater(event.target?.value);
  };

  return (
    <div
      style={{
        fontFamily: "Poppins",
        position: "relative",
        marginTop: `${marginTop ?? "1rem"}`,
        width: `${width ?? "100%"}`
      }}>
      {label?.length! > 0 && (
        <>
          <div
            style={{
              position: "absolute",
              left: "10px",
              background: "#fff",
              paddingLeft: "0.3rem",
              paddingRight: "5px",
              marginRight: "0.6rem",
              top: "0.2rem",
              height: "10px"
            }}>
            <span
              style={{
                left: "0px",
                width: "fit-content",
                fontSize: "0.8rem",
                visibility: "hidden"
              }}>
              {" "}
              {label}
            </span>
          </div>
          <span
            style={{
              position: "absolute",
              color: "#764CBF",
              left: "13px",
              width: "fit-content",
              fontSize: "0.8rem",
              verticalAlign: "top"
            }}>
            {" "}
            {label}
          </span>
        </>
      )}
      <div
        style={{
          border: "0.5px solid #4F3199",
          width: "99%",
          height: `${height ?? "3.5rem"}`,
          borderRadius: "5px",
          marginTop: "0.5rem",
          background: "#fff",
          boxShadow: "2px 2px 6px #CBC9C9"
        }}>
        <input
          disabled={disable}
          ref={reference}
          type={isPassword ? "password" : "text"}
          onChange={onChange}
          style={{
            fontSize: "1.1em",
            marginTop: "0.7rem",
            border: "none",
            color: "black",
            width: "90%",
            outline: "none",
            lineHeight: 1,
            textAlign: `${align ?? "left"}`
          }}
          name="account-number-text"
          placeholder={placeholder}
          autoFocus={focus}
        />
      </div>
    </div>
  );
};

export default LabelledInput;
